/** Copy for closing a claim, from the claim page or the workspace. */
export const CLAIM_CLOSE_CONFIG = {
  open: 'Close',
  title: 'Close Claim',
  subtitle: (claimNumber: string) =>
    `Are you sure you want to close <strong>Claim #${claimNumber}</strong>? This action cannot be undone.`,
  back: 'Back',
  confirm: 'Close Claim',
  unpaid: {
    title: (count: number) => (count === 1 ? "1 payment isn't paid yet" : `${count} payments aren't paid yet`),
    text: (count: number) =>
      `Complete or void ${count === 1 ? 'it' : 'them'} on the Payments tab, then close the claim.`,
  },
  closed: { title: 'Closed Claim', text: 'Claim has successfully been closed.' },
  failed: 'Something went wrong',
};
